import { render, staticRenderFns } from "./ArticleTemplate.vue?vue&type=template&id=55b21f48&"
import script from "./ArticleTemplate.vue?vue&type=script&lang=js&"
export * from "./ArticleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports